import { render } from "./GalleryBoxEditingState.vue?vue&type=template&id=2ec3895a"
import script from "./GalleryBoxEditingState.vue?vue&type=script&lang=js"
export * from "./GalleryBoxEditingState.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2ec3895a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ec3895a', script)) {
    api.reload('2ec3895a', script)
  }
  
  module.hot.accept("./GalleryBoxEditingState.vue?vue&type=template&id=2ec3895a", () => {
    api.rerender('2ec3895a', render)
  })

}

script.__file = "resources/js/Pages/Station/Gallery/GalleryBoxEditingState.vue"

export default script